const convertEventResponse = eventResponse => {
    return {
        accountId: eventResponse['account-id'],
        id: eventResponse.id,
        groupId: eventResponse.groupId,
        uniqueName: eventResponse['unique-name']?.toString(),
        name: eventResponse.name,
        created: eventResponse.created,
        startDate: eventResponse['start-date'],
        endDate: eventResponse['end-date'],
        timeZone: eventResponse['time-zone-id'],
        localStartDate: eventResponse['local-start-date'],
        localEndDate: eventResponse['local-end-date'],
        headerLogoUrl: eventResponse['header-logo-url'],
        logoSet: eventResponse['logo-set'],
        homepageUrl: eventResponse['homepage-url'],
        faviconUrl: eventResponse['favicon-url'],
        supportEmail: eventResponse['support-email'],
        type: eventResponse.eventType,
        attendanceType: eventResponse.attendanceType,
    };
};

export default convertEventResponse;
